<router-outlet />

<!-- Global Notification Toast -->
<app-notification-toast />
